<script>
export default {
    name: 'schema.org',
    props: ['info'],
    render: function (createElement) {
        return createElement(
            'script',
            { attrs: { type: 'application/ld+json' } },
            this.schemaInfo && JSON.stringify(this.schemaInfo)
        );
    },
    computed: {
        schemaInfo() {
            if (!this.info) {
                return '';
            }
            if (Array.isArray(this.info)) {
                return this.info.map(obj => {
                    if (obj.description && obj.description.length > 5000) {
                        obj.description = obj.description.slice(0, 5000);
                    }
                    obj['@context'] = 'http://schema.org';
                    return obj;
                });
            }
            return Object.assign({}, this.info, {
                '@context': 'http://schema.org'
            });
        }
    }
};
</script>
